import React, { useMemo } from 'react';
import styled from '@emotion/styled';

type ProgressProps = {
  currentStep: number;
  stepNames: string[];
};

const Container = styled.div`
  width: 100%;
  height: 6px;
  background-color: #e5e5e5;
`;

const ProgressBar = styled.div`
  height: 100%;
  background-color: var(--productPrimary);
  transition: width 1s ease-in-out;
`;

const Progress = ({ currentStep, stepNames }: ProgressProps) => {
  const stepCount = stepNames.length;

  const normalisedProgress = useMemo(
    () => Math.round((Math.min(Math.max(currentStep, 0.1), stepCount - 0.1) / stepCount) * 100) / 100,
    [currentStep, stepCount]
  );

  return (
    <Container>
      <ProgressBar style={{ width: `${normalisedProgress * 100}%` }} />
    </Container>
  );
};

export default Progress;
